import { ButtonBase } from '#src/atoms/buttons/ButtonBase/index.tsx';
import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { Dot } from '#src/atoms/icons/Dot.tsx';
import { iconAngleLeft } from '#src/atoms/icons/system/iconAngleLeft.ts';
import { iconAngleRight } from '#src/atoms/icons/system/iconAngleRight.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { range } from '#src/lib/arrays.ts';

type Props = {
  numberOfItems: number;
  activeIndex: number;
  onSelect?: (index: number) => void;
};

export const Switcher = ({ numberOfItems, activeIndex, onSelect }: Props) => {
  if (numberOfItems <= 1) {
    return null;
  }

  return (
    <Horizontal gap={2}>
      <Horizontal gap={0.5}>
        <IconButton
          disableDebounce
          size="compact"
          color="tertiary"
          icon={iconAngleLeft}
          disabled={activeIndex === 0}
          onClick={() => onSelect?.(activeIndex - 1)}
        />
        <IconButton
          disableDebounce
          size="compact"
          color="tertiary"
          icon={iconAngleRight}
          disabled={activeIndex === numberOfItems - 1}
          onClick={() => onSelect?.(activeIndex + 1)}
        />
      </Horizontal>
      <Horizontal>
        {range(numberOfItems).map(i => (
          <ButtonBase key={i} onClick={() => onSelect?.(i)}>
            <Dot
              color={i === activeIndex ? 'var(--c-white)' : 'var(--c-nd-150)'}
              size={1}
            />
          </ButtonBase>
        ))}
      </Horizontal>
    </Horizontal>
  );
};
